var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExpand(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.875 11.875C17.2202 11.875 17.5 12.1548 17.5 12.5V16.875C17.5 17.2202 17.2202 17.5 16.875 17.5H12.5C12.1548 17.5 11.875 17.2202 11.875 16.875C11.875 16.5298 12.1548 16.25 12.5 16.25H16.25V12.5C16.25 12.1548 16.5298 11.875 16.875 11.875Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.433 11.4331C11.677 11.189 12.0728 11.189 12.3169 11.433L16.9184 16.0334C17.1626 16.2774 17.1626 16.6732 16.9186 16.9173C16.6745 17.1614 16.2788 17.1614 16.0347 16.9174L11.4331 12.317C11.189 12.073 11.189 11.6772 11.433 11.4331Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.5 3.125C2.5 2.77982 2.77982 2.5 3.125 2.5H7.5C7.84518 2.5 8.125 2.77982 8.125 3.125C8.125 3.47018 7.84518 3.75 7.5 3.75H3.75V7.5C3.75 7.84518 3.47018 8.125 3.125 8.125C2.77982 8.125 2.5 7.84518 2.5 7.5V3.125Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.08144 3.08253C3.32549 2.83842 3.72121 2.83837 3.96532 3.08242L8.56689 7.68281C8.81099 7.92685 8.81104 8.32258 8.567 8.56669C8.32295 8.8108 7.92722 8.81085 7.68312 8.5668L3.08155 3.96641C2.83744 3.72237 2.83739 3.32664 3.08144 3.08253Z",
    fill: "currentColor"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.875 3.125C11.875 2.77982 12.1548 2.5 12.5 2.5H16.875C17.2202 2.5 17.5 2.77982 17.5 3.125V7.5C17.5 7.84518 17.2202 8.125 16.875 8.125C16.5298 8.125 16.25 7.84518 16.25 7.5V3.75H12.5C12.1548 3.75 11.875 3.47018 11.875 3.125Z",
    fill: "currentColor"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.9173 3.08144C17.1614 3.32549 17.1614 3.72121 16.9174 3.96532L12.317 8.56689C12.073 8.81099 11.6772 8.81104 11.4331 8.567C11.189 8.32295 11.189 7.92722 11.433 7.68312L16.0334 3.08155C16.2774 2.83744 16.6732 2.83739 16.9173 3.08144Z",
    fill: "currentColor"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.125 11.875C3.47018 11.875 3.75 12.1548 3.75 12.5V16.25H7.5C7.84518 16.25 8.125 16.5298 8.125 16.875C8.125 17.2202 7.84518 17.5 7.5 17.5H3.125C2.77982 17.5 2.5 17.2202 2.5 16.875V12.5C2.5 12.1548 2.77982 11.875 3.125 11.875Z",
    fill: "currentColor"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.56689 11.433C8.811 11.677 8.81105 12.0728 8.567 12.3169L3.96661 16.9184C3.72256 17.1626 3.32684 17.1626 3.08273 16.9186C2.83862 16.6745 2.83857 16.2788 3.08261 16.0347L7.683 11.4331C7.92705 11.189 8.32278 11.189 8.56689 11.433Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpand);
export default __webpack_public_path__ + "static/media/Expand.56d91f836a9556c6544c4f46cb9a17e5.svg";
export { ForwardRef as ReactComponent };